import { Model } from '@vuex-orm/core'

export default class Event extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'events'

  static primaryKey = '_id'

  // List of all fields (schema) of the post model. `this.attr` is used
  // for the generic field type. The argument is the default value.
  static fields () {
    return {
      _id: this.attr(null),
      candidate_id: this.attr(null),
      scoreform_id: this.attr(null),
      has_meet_link: this.attr(false),
      has_meeting_transcript: this.attr(false),
      job_id: this.attr(null),
      stage_id: this.attr(null),
      type: this.attr(null),
      location: this.attr(null),
      note: this.attr(null),
      assigned_users: this.attr(null),
      participants: this.attr(null),
      start_at: this.attr(null),
      duration: this.attr(null),
      has_group_event: this.attr(null),
      author_user_id: this.attr(null)
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/Event.js